<template>
    <div>
        <v-btn class="mx-2 white--text appointment-btn" medium color="black" @click="appointmentDialog = true" :disabled="assignment.taskAssignments?.length === 0">
            <v-icon dark>mdi-calendar-clock</v-icon>Ραντεβου
        </v-btn>
        <v-dialog v-model="appointmentDialog" max-width="800">
            <div class="background">
                <v-toolbar flat dark>
                    <v-toolbar-title>Προγραμματισμένα Ραντεβού</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="appointmentDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="pa-0" style="height: 80vh;">
                    <alert v-if="showAlert" :show-alert="showAlert" :message="message" :type="type" />
                    <div v-for="(taskAssignment, index) of assignment.taskAssignments" :key="index">
                        <v-card class="mx-2 my-2 card">
                            <div class="first">
                                <v-card-title>
                                    {{ getTypeText(taskAssignment.type) }}
                                </v-card-title>
                                <v-card-subtitle class="subtitle-wrapper">
                                    <div class="assignee-name">{{ taskAssignment.assignee.firstName }}</div>
                                    <div class="ml-1 assignee-name">{{ taskAssignment.assignee.lastName }}</div>
                                    <v-chip
                                        v-for="role in taskAssignment.assignee.roles"
                                        :key="role.role"
                                        :color="getColor(role.role)"
                                        class="role-chip"
                                        small
                                    >
                                        {{ getRoleText(role) }}
                                    </v-chip>
                                </v-card-subtitle>
                            </div>
                            <div class="second">
                                <v-card-text>
                                    <div class="desired-datetime">
                                        Επιθυμητή: {{ getGreekDateTime(taskAssignment.datetime) }}
                                        <v-btn
                                            v-if="editIndex === index && !selectedDate && !taskAssignment.finalDatetime && !readOnly && canEdit(taskAssignment)"
                                            class="white--text ml-1"
                                            color="green"
                                            fab
                                            out
                                            x-small
                                            @click="() => selectedDate = taskAssignment.datetime"
                                        >
                                            <v-icon sm>mdi-check</v-icon>
                                        </v-btn>
                                    </div>
                                    <div class="final-date">
                                        <span class="mr-1">Επιβεβαιωμένη:</span>
                                        <v-btn
                                            v-if="selectedDate && editIndex === index && !readOnly && canEdit(taskAssignment)"
                                            class="white--text ml-1"
                                            color="green"
                                            fab
                                            out
                                            x-small
                                            @click="onSubmit(taskAssignment)"
                                        >
                                            <v-icon sm>mdi-check</v-icon>
                                        </v-btn>
                                        <span v-if="editIndex === index">
                                            <custom-datetime :value="taskAssignment.finalDatetime || selectedDate || ''" :readOnly="false"  @onSelect="appointmentDateSelected"/>
                                        </span>
                                        <span v-else-if="taskAssignment.finalDatetime">{{ getGreekDateTime(taskAssignment.finalDatetime) }}</span>
                                        <span v-else>-</span>
                                        <v-btn
                                            v-if="editIndex !== index && !readOnly && canEdit(taskAssignment)"
                                            class="white--text ml-2"
                                            color="black"
                                            fab
                                            x-small
                                            @click="() => editIndex = index"
                                        >
                                            <v-icon medium>mdi-pencil</v-icon>
                                        </v-btn>
                                    </div>
                                </v-card-text>
                            </div>
                        </v-card>
                    </div>
                </v-card-text>
            </div>
        </v-dialog>
    </div>
</template>
<script>
    import momentTimezone from 'moment-timezone'
    import CustomDatetime from '@/components/CustomDatetime'
    import assignmentService from '@/services/assignment'
    import Alert from '@/components/Alert'

    export default {
        components: { CustomDatetime, Alert },
        props: {
            assignment: {
                type: Object,
                default: () => { return {} },
                required: true
            },
            currentUser: {
                type: Object,
                default: () => { return {} },
                required: true
            },
            readOnly: {
                type: Boolean,
                default: () => { return true },
                required: true
            }
        },
        computed: {
            userRoles() {
                return this.currentUser?.roles?.map(role => role.role) || []
            },
            config() {
                return this.$store.getters.getConfig || {}
            },
            taskTypes() {
                return this.config?.taskTypes || []
            }
        },
        data: () => {
            return {
                appointmentDialog: false,
                editIndex: -1,
                selectedDate: null,
                showAlert: false,
                message: null,
                type: null
            }
        },
        methods: {
            canEdit(taskAssignment) {
                if (this.containsAny(['ROLE_ADMIN'], this.userRoles)) {
                    return true
                }
                if (this.containsAny(['ROLE_CONTRACTOR', 'ROLE_COORDINATOR'], this.userRoles) && this.currentUser?.contractor?.id === this.assignment?.contractor?.id) {
                    return true
                }
                if (taskAssignment.assignee?.id === this.currentUser.id) {
                    return true
                }
                return false
            },
            containsAny(arr1, arr2) {
                return arr1.some(item => arr2.includes(item))
            },
            getTypeText(type) {
                return this.taskTypes.find(taskType => taskType.value === type)?.name || ''
            },
            getColor(role) {
                switch (role) {
                case 'ROLE_ADMIN': return '#5f9595'
                case 'ROLE_BLOWER': return '#c59dc2'
                case 'ROLE_AUTOPSY': return '#f0bc68'
                case 'ROLE_EARTH_WORKER': return '#723d46'
                case 'ROLE_CONSTRUCTOR_A': return '#c4d7d1'
                case 'ROLE_CONSTRUCTOR_B': return '#c4d7d1'
                case 'ROLE_WELDER': return '#aab8bb'
                }
            },
            getRoleText(role) {
                return role.role.split('ROLE_')[1]
            },
            getGreekDateTime(utcDateTime) {
                return momentTimezone(utcDateTime).utc().tz('Europe/Athens').format('YYYY-MM-DD HH:mm').toString()
            },
            getGreekDate(utcDateTime) {
                return momentTimezone(utcDateTime).utc().tz('Europe/Athens').format('YYYY-MM-DD').toString()
            },
            getGreekTime(utcDateTime) {
                return momentTimezone(utcDateTime).utc().tz('Europe/Athens').format('HH:mm').toString()
            },
            appointmentDateSelected(e) {
                this.selectedDate = e
            },
            onSubmit(taskAssignment) {
                assignmentService.appointmentUpdate(this.assignment.id, { taskAssignmentId: taskAssignment.id, type: taskAssignment.type, appointmentDate: this.selectedDate })
                    .then(resp => {
                        this.editIndex = -1
                        this.selectedDate = null
                        this.$emit('appointment-refresh')
                        this.setAlert('Επιτυχής Καταχώριση', 'success')
                    }).catch(error => {
                        this.setAlert(error.message, 'error')
                    })
            },
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { this.showAlert = false }, 7000)
            }
        }
    }
</script>
<style scoped>
.subtitle-wrapper {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
}

.assignee-name {
    align-self: center;
    font-weight: 500;
}
.role-chip {
    color: white;
    margin-left: 0.3rem;
}
.desired-datetime {
    color: rgb(240, 188, 104);
}
.first, .second {
    width: 50%;
    min-width: 280px;
    align-content: center;
}

.card {
    display: flex;
    flex-wrap: wrap;
}

.final-date {
    margin-top: 1rem;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    font-weight: 500;
}
.background {
    background-color: gray;
}
@media only screen and (max-width: 657px) {
    .first, .second {
        width: 100%;
    }
}
</style>
